import Vue from 'vue';
import { Message } from 'element-ui';

const USER_URL = 'me';
const LOGIN_URL = 'login';

const state = {
  user: {},
  notifications: [],
  roles: {},
  token: window.localStorage.getItem('jwtToken')
    ? window.localStorage.getItem('jwtToken')
    : false,
};

const getters = {};

const actions = {
  Login({ commit }, params) {
    // 这里不直接返回axios.post, 因为后面的链式调用会继续传入reject
    return new Promise((resolve, reject) => {
      Vue.axios.post(LOGIN_URL, params, { headers: { Authorization: '' } }).then((response) => {
        commit('SetToken', response.headers.authorization);
        resolve();
      }, ({ response }) => {
        // 登录的401需要特别对待，不能进入refresh-token
        if (response.status === 401) {
          Message.error({
            message: '无法登录，请确认您的用户名密码输入',
            duration: 5000,
          });
        } else {
          Vue.prototype.$sys.alarmResponse(response);
        }
        reject();
      });
    });
  },
  GetUser({ commit }) {
    return Vue.axios.get(USER_URL).then((response) => {
      commit('SetUser', response.data);
    }, ({ response }) => {
      Vue.prototype.$sys.alarmResponse(response);
    });
  },
  // GetRoles({ commit }) {
  //   return Vue.axios.get('xdata/role').then((response) => {
  //     commit('SetRoles', response.data);
  //   }, ({ response }) => {
  //     Vue.sys.alarmResponse(response);
  //   });
  // },
};
/* eslint-disable no-shadow, no-param-reassign */
const mutations = {
  SetToken(state, token = false) {
    state.token = token;
    window.localStorage.setItem('jwtToken', token);
  },
  SetUser(state, user) {
    state.user = user;
  },
  // SetRoles(state, roles) {
  //   state.roles = roles;
  // },
  Logout(state) {
    window.localStorage.removeItem('jwtToken');
    state.token = false;
    state.user = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
